<template>
  <div
    class="profile-section secondary"
    ref="profileSection"
    id="profileSection"
  >
    <!-- start of header -->
    <div class="section-header">
      <v-layout row>
        <v-flex lg6>
          <div class="section-name">{{ layoutSetting.section.caption }}</div>
          <template v-if="assist.tool.isNotEmpty(dataSource.sectionStamp)">
            <v-tooltip top max-width="800px" v-for="(item, index) of dataSource.sectionStamp" :key="index">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small :color="item.color">{{item.icon}}</v-icon>
              </template>
              <span v-if="item.type === assist.dataType.StampActionTypeEnum.DECLINE_STAMP.value">Decline By {{ item.stampedBy }} At {{ assist.tool.formatDateTime(item.stampedAt) }}</span>
              <span v-else>Stamped By {{ item.stampedBy }} At {{ assist.tool.formatDateTime(item.stampedAt) }}</span>
            </v-tooltip>
          </template>
          <v-tooltip top max-width="800px" v-else-if="layoutSetting.section.name !== 'statement'">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small color="grey">help</v-icon>
            </template>
            <span>No Stamp Data</span>
          </v-tooltip>
          <div class="section-name pl-1" v-if="assist.tool.isNotEmpty(layoutSetting.section.speechCraftCode)" @mouseover="showTooltip(layoutSetting.section.speechCraftCode)">
            <v-tooltip
              :bottom="layoutSetting.section.tooltipPosition === 'bottom'"
              :right="layoutSetting.section.tooltipPosition === 'right'"
              :left="layoutSetting.section.tooltipPosition === 'left'"
              :top="layoutSetting.section.tooltipPosition === 'top'" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <i class="fad fa-lightbulb text-warning light-size" v-bind="attrs" v-on="on"></i>
              </template>
              <div v-html="toolTipData"></div>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex lg6>
          <div class="section-action">
            <template v-if="(isShowElement(authorization.privileges, layoutSetting.section.code, assist.dataType.PrivilegeType.WRITABLE) && isOperational() && (isEdit() || isRetention()))
            || isWithdrawnLock()">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    color="primary"
                    v-on="on"
                    slot="activator"
                    @click="showProfileSectionDialog('EDIT')">
                    <v-icon>notes</v-icon>
                  </v-btn>
                </template>
                <span>EDIT</span>
              </v-tooltip>
            </template>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <!-- start of header //:~ -->

    <!-- start of title -->
    <div class="section-banner" v-if="layoutSetting.title && !((loan.loanType === assist.dataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) && (layoutSetting.section.name === assist.sectionFeature.LOAN_DETAILS))" :style="layoutSetting.section.name === assist.sectionFeature.LOAN_DETAILS ? 'width: 93%' : ''">
      <v-layout row v-if="layoutSetting.title instanceof Array">
        <v-flex v-for="(title, index) in layoutSetting.title" :key="index" :class="'lg' + 12 / layoutSetting.title.length">
          <label v-if="showTitle(assist.dataType.LoanTypeEnum.INSTALLMENT_LOAN.value)">{{ title.label.installmentLoan }}</label>
          <label v-if="showTitle(assist.dataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value)">{{ title.label.multipleAdvanceLoan }}</label>
          <label v-if="typeof title.label === 'string'" style="font-size: 16px;">{{ title.label }}</label>
          <strong :class="title.class" :style="isShowLoanAmountChangeClass(title)" style="font-size: 18px !important;">
            {{ filterDate(setUpData, title) }}
          </strong>
          <template v-if="title.action === 'triggerRecalculateLoanAmount' && isShowLoanAmountChangeIcon()">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <i icon class="material-icons text-danger"
                   v-bind="attrs" v-on="on"
                   style="cursor: pointer; font-size: 16px">warning</i>
              </template>
              <span>{{ loanAmountChangeText }}</span>
            </v-tooltip>
          </template>
          <template v-if="assist.tool.isNotEmpty(title.iconItems)">
            <template v-for="(item, index) in title.iconItems">
              <v-tooltip v-if="isShowElement(authorization.privileges, item.code, assist.dataType.PrivilegeType.WRITABLE) && isOperational() && (isEdit() || isRetention()) && hasSpecialConsiderationCustomer(item)" bottom :key="assist.tool.getRandomKey(index)">
                <template v-slot:activator="{ on, attrs }">
                  <i icon class="material-icons" :class="item.class" v-bind="attrs" v-on="on" style="cursor: pointer;" @click="triggerAmount(item.action)">{{ item.icon }}</i>
                </template>
                <span>{{ item.tooltip }}</span>
              </v-tooltip>
            </template>
          </template>
          <template v-else-if="isShowElement(authorization.privileges, title.code, assist.dataType.PrivilegeType.EXECUTABLE) && isOperational() && (isEdit() || isRetention())">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <i icon class="material-icons text-warning"
                   v-bind="attrs" v-on="on"
                   style="cursor: pointer;"
                   @click="triggerAmount(title.action)">{{ title.icon }}</i>
              </template>
              <span>{{ title.tooltip }}</span>
            </v-tooltip>
          </template>
        </v-flex>
      </v-layout>
      <div v-else>
        <v-layout row>
          <v-flex lg6>
            <strong class="text-inverse">
              {{ assist.tool.fieldRender(dataSource.sectionData, layoutSetting.title.template, null, null, layoutSetting.title.case) }}
            </strong>
            <v-tooltip bottom v-if="personalNameInBlackList">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small color="red">highlight_off</v-icon>
              </template>
              <span>personalName in blacklist</span>
            </v-tooltip>
            <v-tooltip bottom v-if="employmentNameInBlackList">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small color="red">highlight_off</v-icon>
              </template>
              <span>employmentName in blacklist</span>
            </v-tooltip>
          </v-flex>
          <v-flex lg6>
            <div v-if="layoutSetting.section.name === assist.sectionFeature.PERSONAL" class="section-action" style="float: right">
              <div style="display: inline-block" v-for="(optIn, index) in optInArray" :key="index">
                <v-tooltip bottom v-if="optIn.display">
                  <template v-slot:activator="{ on, attrs }">
                    <i :class="`${optIn.style} mr-1`" :key="index" v-on="on"></i>
                  </template>
                  <span>{{ optIn.tooltip }}</span>
                </v-tooltip>
              </div>
            </div>
            <div v-if="layoutSetting.section.name === assist.sectionFeature.EMPLOYMENT" class="section-action" style="float: right">
              <template v-for="(optIn, index) in emInArray">
                <v-tooltip bottom v-if="optIn.display" :key="index">
                  <template v-slot:activator="{ on, attrs }">
                    <i :class="`${optIn.style} mr-1`" :key="index" v-on="on"></i>
                  </template>
                  <span>{{ optIn.tooltip }}</span>
                </v-tooltip>
              </template>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <!-- end of title //:~ -->

    <!-- start of form section -->
    <div class="section-form" v-if="layoutSetting.section.type === 'form'" :style="layoutSetting.section.name === assist.sectionFeature.LOAN_DETAILS ? 'width: 93%' : ''">
      <v-layout row wrap>
        <v-flex
          v-if="loan.loanType === assist.dataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value && layoutSetting.section.name === assist.sectionFeature.LOAN_DETAILS"
          class="p-v-0 lg12"
          :key="assist.tool.getRandomKey (100)"
        >
          <div style="margin: 10px"></div>
        </v-flex>
        <template
          v-for="(field, index) in formLayoutSetting"
        >
          <v-flex v-if="field.blankRow" class="p-v-0 lg12" :key="assist.tool.getRandomKey (index)">
            <div style="margin: 10px"></div>
          </v-flex>
          <v-flex
            class="p-v-0"
            :class="field.labelClass ? field.labelClass : 'lg3'"
            :key="assist.tool.getRandomKey (index)"
            v-if="isDisplayField(field.fieldKey, field.loanType) && !field.blankRow && !field.divider && isShowPaymentMode(field.individualTransactionMode)"
          >
            <label class="field-name">
              {{ field.label }}
              <template v-if="field.hasBlacklistTip && isShowBlackListIcon[assist.dataType.BlacklistEnum.STATE] === true
               && isShowBlackListIcon[assist.dataType.BlacklistEnum.ZIP] === false && field.blackListFieldKey === assist.dataType.BlacklistEnum.STATE">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small color="red">highlight_off</v-icon>
                  </template>
                  <span>state in blacklist</span>
                </v-tooltip>
              </template>
              <template v-else-if="field.hasBlacklistTip && isShowBlackListIcon[assist.dataType.BlacklistEnum.ZIP]
               === true && isShowBlackListIcon[assist.dataType.BlacklistEnum.STATE] === false && field.blackListFieldKey === assist.dataType.BlacklistEnum.STATE">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small color="red">highlight_off</v-icon>
                  </template>
                  <span>zip in blacklist</span>
                </v-tooltip>
              </template>
              <template v-else-if="field.hasBlacklistTip && isShowBlackListIcon[assist.dataType.BlacklistEnum.ZIP]
               === true && isShowBlackListIcon[assist.dataType.BlacklistEnum.STATE] === true && field.blackListFieldKey === assist.dataType.BlacklistEnum.STATE">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small color="red">highlight_off</v-icon>
                  </template>
                  <span>state and zip in blacklist</span>
                </v-tooltip>
              </template>
              <template v-else-if="field.hasBlacklistTip && isShowBlackListIcon[field.blackListFieldKey] === true">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small color="red">highlight_off</v-icon>
                  </template>
                  <span>{{ field.blackListFieldKey }} in blacklist</span>
                </v-tooltip>
              </template>
              <!--   zipCode、state、email的warning校验   -->
              <template v-if="field.hasWarningTip && isShowWarningIcon[field.warningListFieldKey]">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small color="orange">error</v-icon>
                  </template>
                  <span v-if="field.warningListFieldKey === assist.dataType.WarningListEnum.ZIP">zip code is mismatched with state</span>
                  <span v-if="field.warningListFieldKey === assist.dataType.WarningListEnum.EMAIL">Please confirm the customer's email domain - '.edu'.</span>
                  <span v-if="field.warningListFieldKey === assist.dataType.WarningListEnum.LAST_PAY_DAY">Inconsistent between Last Payroll Date and DD</span>
                </v-tooltip>
              </template>
              <i v-if="assist.tool.isNotEmpty(field.speechCraftCode)"  @mouseover="showTooltip(field.speechCraftCode)">
                <v-tooltip
                  :bottom="field.tooltipPosition === 'bottom'"
                  :right="field.tooltipPosition === 'right'"
                  :left="field.tooltipPosition === 'left'"
                  :top="field.tooltipPosition === 'top'" max-width="800px">
                  <template v-slot:activator="{ on, attrs }">
                    <i class="fad fa-lightbulb text-warning light-size p-r-5" v-bind="attrs" v-on="on"></i>
                  </template>
                  <div v-html="toolTipData"></div>
                </v-tooltip>
              </i>
              <template v-if="field.iconItems">
                <v-tooltip bottom max-width="800px" v-for="(iconItem, index) in field.iconItems" :key="`icon-item-${index}`" >
                  <template v-if="
                    isShowElement(authorization.privileges, iconItem.code, assist.dataType.PrivilegeType.WRITABLE)
                  && isOperational()
                  && (isEdit() || isRetention())
                  && hasSpecialConsiderationCustomer(iconItem)" v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      :class="iconItem.class"
                      @click="triggerAmount(iconItem.action)"
                      v-bind="attrs"
                      v-on="on"
                    >{{ iconItem.icon }}</v-icon>
                  </template>
                  <span>{{ iconItem.tooltip }}</span>
                </v-tooltip>
              </template>
              <template v-if="field.code && isShowElement(authorization.privileges, field.code, assist.dataType.PrivilegeType.EXECUTABLE) && isOperational() && (isEdit() || isRetention()) && !assist.tool.isWithdrawnStatus(loan.loanStatus)">
                <v-tooltip bottom max-width="800px">
                  <template v-slot:activator="{ on, attrs }">
                    <i class="fad text-warning" :class="field.icon"
                       @click="triggerAmount(field.action)"
                       style="cursor: pointer;"
                       v-bind="attrs"
                       v-on="on"
                    >
                    </i>
                  </template>
                  <span>{{ field.tooltip }}</span>
                </v-tooltip>
              </template>
            </label>
          </v-flex>
          <v-flex class="p-v-0 field-container"
                  :class="field.valueClass ? field.valueClass : field.isWholeRow ? 'lg9' : 'lg3'"
                  :key="assist.tool.getRandomKey (index)"
                  v-if="isDisplayField(field.fieldKey, field.loanType) && !field.blankRow && !field.divider && isShowPaymentMode(field.individualTransactionMode)"
          >
            <template v-if="field.label === 'Amount Financed' && isShowLoanAmountChangeIcon()">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon icon class="material-icons text-danger"
                     v-bind="attrs" v-on="on"
                     style="cursor: pointer; font-size: 16px">warning</v-icon>
                </template>
                <span>{{ loanAmountChangeText }}</span>
              </v-tooltip>
            </template>
            <label class="field-value"
                   :class="field.class"
                   :style="isShowLoanAmountChangeClass(field)"
                   :title="assist.tool.fieldRender(dataSource.sectionData, field.template, field.format, getOptions(field.options), field.case, field, operator, currentLockedId, layoutSetting.section.code, authorization.privileges)"
            >
              {{ assist.tool.fieldRender(dataSource.sectionData, field.template, field.format, getOptions(field.options), field.case, field, operator, currentLockedId, layoutSetting.section.code, authorization.privileges) }}
            </label>
          </v-flex>
          <v-flex v-if="field.divider" :key="assist.tool.getRandomKey (index)" class="p-v-0 p-h-0" :class="field.class ? field.class : 'lg6'">
            <v-divider class="m-v-0"  :key="assist.tool.getRandomKey (index)"></v-divider>
          </v-flex>
          <v-flex v-if="field.divider && !field.class" :key="assist.tool.getRandomKey (index)" class="p-v-0 p-h-0" lg6></v-flex>
        </template>
      </v-layout>
    </div>
    <!-- end of form section //:~ -->
    <!-- start of question -->
    <div class="section-question" v-if="layoutSetting.questionGroup">
      <v-divider class="no-bg m-v-5"></v-divider>
      <v-layout row>
        <v-flex lg12>
          <ul class="fa-ul m-0">
            <template v-for="(questionTemplate, index) in dataSource.questionTemplateData">
              <li :key="assist.tool.getRandomKey(index)">
                <span class="fa-li">
                  <i class="fad fa-caret-right"></i>
                </span>
                {{ questionTemplate.question }}
                <span class="m-l-10">
                  <b>{{ assist.tool.isEmpty(extension.questionAnswerData[questionTemplate.id]) ? "N/A" : extension.questionAnswerData[questionTemplate.id].text }}</b>
                  <span class="text-blue" v-if="questionTemplate.id === 2">
                    {{ assist.tool.isEmpty(extension.questionAnswerData[questionTemplate.id]) ? '' : extension.questionAnswerData[questionTemplate.id].appendix }}
                  </span>
                </span>
              </li>
            </template>
          </ul>
        </v-flex>
      </v-layout>
    </div>
    <!-- end of question //:~ -->
    <!-- start of card -->
    <div class="section-card" v-if="layoutSetting.section.type === 'card'">
      <v-tooltip v-for="(field, index) in formLayoutSetting"  :key="assist.tool.getRandomKey (index)" bottom>
        <template  v-slot:activator="{ on, attrs }">
          <v-card
            tile
            class="cardClass"
            v-if="isDisplayField(field.fieldKey, field.loanType) && !field.blankRow && !field.divider && isShowPaymentMode(field.individualTransactionMode)"
            v-bind="attrs"
            v-on="on"
          >
            <v-list-item-title class="mt-1">
              {{ field.label }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-h5 mt-3">
              {{  assist.tool.collectionFieldRender(feeList, field.template, field.format, field.type) ? assist.tool.collectionFieldRender(feeList, field.template, field.format, field.type) : '$0.00' }}
            </v-list-item-subtitle>
          </v-card>
        </template>
        <div v-for="(formField, index) in layoutSetting.formFields" :key="index" style="display: flex; justify-content:space-between; width: 180px">
          <span>{{formField.label}}</span>
          <span>{{assist.tool.collectionFieldRender(feeList, formField.template, 'currency', field.type) ? assist.tool.collectionFieldRender(feeList, formField.template, 'currency', field.type) : '$0.00' }}</span>
        </div>
      </v-tooltip>
    </div>
    <!-- end of card -->
    <!-- start of table -->
    <simple-table
      class="section-table"
      v-if="layoutSetting.section.type === 'table'"
      :desserts="dataSource.tableData"
      :header="layoutSetting.sectionFields"
      :height="180"
      :color="$vuetify.theme.themes.light.secondary"
      fontColor="#002B7F"
    ></simple-table>
    <!-- end of table //:~ -->

    <!-- start of some dialog -->
    <v-dialog
      v-model="dialog.profileSectionDialog.display" persistent
      :max-width="layoutSetting.dialogWidth === undefined ? '950px' : layoutSetting.dialogWidth">
      <old-profile-section-dialog
        :loan="loan"
        :slaveLoanId="slaveLoanId"
        :layoutSetting="layoutSetting"
        :dataSource="dataSource"
        :extension="extension"
        :setting="dialog.profileSectionDialog"
        :isShowWarningIcon="isShowWarningIcon"
        @updatePersonalNameInBlackList="updatePersonalNameInBlackList"
        @updateEmploymentNameInBlackList="updateEmploymentNameInBlackList"
      ></old-profile-section-dialog>
    </v-dialog>
    <v-dialog v-model="dialog.paymentPlanDialog.display" persistent max-width="500px">
      <generate-payment-plan-dialog
        :loan="loan"
        :dataSource="dataSource"
        :slaveLoanId="slaveLoanId"
        @hideDialog="hidePaymentPlanEventHandler"
      ></generate-payment-plan-dialog>
    </v-dialog>
    <v-dialog v-model="dialog.specialConsiderationCustomerDialog.display" persistent max-width="410px">
      <special-consideration-customer-dialog
        :loan="loan"
        @hideDialog="hideSpecialConsiderationCustomerEventHandler"
      ></special-consideration-customer-dialog>
    </v-dialog>
    <v-dialog v-model="dialog.manualSetLoanAmountDialog.display" persistent max-width="500px">
      <manual-set-loan-amount-dialog
        :loan="loan"
        :dataSource="dataSource"
        :manualSetLoanAmountMax="manualSetLoanAmountMax"
        @hideDialog="hideManualSetLoanAmountEventHandler"
        :authorization="authorization"
      ></manual-set-loan-amount-dialog>
    </v-dialog>
    <!-- end of some dialog //:~ -->
  </div>
</template>

<script>
import { Tool, DataType, Crypto, Authentication, Popup } from '@/util/index'
import { OriginationApi, CollectionApi, ProcessingApi, RuntimeApi } from '@/api/pandaria'
import { LIST_INIT_STRUCTURE } from '@/setting/list-header/list-init-structure'
import { _ } from 'vue-underscore'
import SimpleTable from '@/components/widget/table/SimpleTable'
import OldProfileSectionDialog from '@/components/panda/common/dialog/OldProfileSectionDialog'
import GeneratePaymentPlanDialog from '@/components/panda/pre-origination/dialog/GeneratePaymentPlanDialog'
import { SystemEnum } from '@/assets/js'
import SpecialConsiderationCustomerDialog from '@/components/panda/pre-origination/dialog/SpecialConsiderationCustomerDialog'
import ManualSetLoanAmountDialog from '@/components/panda/pre-origination/dialog/ManualSetLoanAmountDialog'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'old-profile-section',
  components: {
    SpecialConsiderationCustomerDialog,
    ManualSetLoanAmountDialog,
    OldProfileSectionDialog,
    SimpleTable,
    GeneratePaymentPlanDialog
  },
  props: {
    layoutSetting: Object,
    loan: Object,
    authorization: Object,
    code: String,
    toolTipData: String,
    slaveLoanId: Number,
    operator: {
      type: Object,
      default: () => {}
    },
    stamp: null,
    blackList: {
      type: Object,
      default: () => {}
    },
    warningList: {
      type: Object,
      default: () => {}
    },
    personalNameInBlackList: Boolean,
    employmentNameInBlackList: Boolean
  },
  data () {
    return {
      dialog: {
        profileSectionDialog: {
          action: '',
          display: false
        },
        paymentPlanDialog: {
          display: false
        },
        specialConsiderationCustomerDialog: {
          display: false
        },
        manualSetLoanAmountDialog: {
          display: false
        }
      },
      setUpData: {},
      feeList: [],
      dataSource: {
        questionTemplateData: [],
        sectionData: {},
        answerData: [],
        tableData: [],
        sectionStamp: []
      },
      extension: {
        questionOptionData: {},
        questionAnswerData: {}
      },
      assist: {
        tool: new Tool(),
        dataType: DataType,
        sectionFeature: SystemEnum.SECTION_FEATURE
      },
      score: {
        sectionData: {}
      },
      currentLockedId: -1,
      optInArray: JSON.parse(JSON.stringify(LIST_INIT_STRUCTURE.OPT_IN_ARRAY)),
      emInArray: JSON.parse(JSON.stringify(LIST_INIT_STRUCTURE.EM_IN_ARRAY)),
      questionTemplate: [],
      portfolioJson: {},
      loanAmountChangeIcon: false,
      loanAmountChangeText: 'The current Max Qualified Amount is lower than the last one',
      loanAmountChangeClass: 'text-grey',
      manualSetLoanAmountMax: null,
      isShowPaymentModeHint: false,
      warningData: {
        zip: false,
        email: false,
        lastPayday: false
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    formLayoutSetting () {
      const loanType = this.loan.loanType
      const sectionName = this.layoutSetting.section.name
      if (sectionName === SystemEnum.SECTION_FEATURE.LOAN_DETAILS && loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        return this.layoutSetting.multipleLoanSectionFields
      } else {
        return this.layoutSetting.sectionFields
      }
    },
    isShowBlackListIcon () {
      const result = {}
      Object.assign(result, this.blackList)
      return result
    },
    isShowWarningIcon () {
      const result = {}
      Object.assign(result, this.warningList)
      return result
    }
  },
  watch: {
    loanId () {
      this.toLoadSectionData()
    },
    slaveLoanId () {
      if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.COLLECTION_SUMMARY && this.$route.path.includes('collection')) {
        this.toLoadSectionData()
      }
    },
    'store.getters.getPortfolioJson': {
      handler: function () {
        if (this.layoutSetting.section.name === 'payment-option') {
          this.portfolioJson = this.store.getters.getPortfolioJson
        }
      }
    },
    stamp () {
      if (tool.isNotEmpty(this.stamp)) {
        this.storeStampData(this.stamp[0])
      }
    }
  },
  destroyed () {
    this.$eventBus.$off('saveApprovedAmount')
    this.$eventBus.$off('loanAmountUpdated')
    this.$eventBus.$off('asyncAprToLoanDetailSection')
    this.$eventBus.$off('clearData')
    this.$eventBus.$off('manualSelectBankRecords')
    this.$eventBus.$off('broadcastLockedId')
    this.$eventBus.$off('broadcastOptIn')
    this.$eventBus.$off('paymentScheduleUpdate')
    this.$eventBus.$off('clearScheduleData')
    this.$eventBus.$off('updateStamp')
    this.$eventBus.$off('update-loan-info')
    this.$eventBus.$off('showBlackListIcon')
    this.$eventBus.$off('sectionUpdated')
  },
  mounted () {
    this.$eventBus.$on('updateStamp', target => {
      const $this = this
      const sectionName = this.layoutSetting.section.name
      if (tool.getSectionKeyByFeature(sectionName) === target) {
        $this.initStamp(target)
      }
    })
    if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.LOAN_DETAILS) {
      this.$eventBus.$on('saveApprovedAmount', target => {
        this.dataSource.sectionData.approvedAmount = target.approvedAmount
        this.dataSource.sectionData.totalAmount = target.approvedAmount
        this.dataSource.sectionData.availableAdvanceAmount = this.dataSource.sectionData.loanAmount / 2
        this.$forceUpdate()
      })
      this.$eventBus.$on('loanAmountUpdated', target => {
        const loanAmount = target.loanAmount
        this.dataSource.sectionData.loanAmount = loanAmount
        if (tool.isNotEmpty(target.approvedAmount)) {
          this.dataSource.sectionData.approvedAmount = target.approvedAmount
        } else {
          target.approvedAmount = this.dataSource.sectionData.approvedAmount
        }
        this.dataSource.sectionData.availableAdvanceAmount = loanAmount / 2
        const transferredAmount = this.dataSource.sectionData.transferredAmount || 0
        this.dataSource.sectionData.totalAmount = transferredAmount + this.dataSource.sectionData.approvedAmount
        this.updateLoanAmountChangeIcon(target)
        this.$forceUpdate()
      })
      this.$eventBus.$on('clearData', target => {
        delete this.dataSource.sectionData.approvedAmount
        delete this.dataSource.sectionData.apr
        delete this.dataSource.sectionData.loanAmount
        delete this.dataSource.sectionData.totalAmount
        delete this.dataSource.sectionData.debitCount
        delete this.dataSource.sectionData.firstDebitDate
        delete this.dataSource.sectionData.lastDebitDate
        delete this.dataSource.sectionData.regularAmount
        delete this.dataSource.sectionData.availableAdvanceAmount
        this.$forceUpdate()
      })
      this.$eventBus.$on('clearScheduleData', target => {
        delete this.dataSource.sectionData.apr
        delete this.dataSource.sectionData.debitCount
        delete this.dataSource.sectionData.firstDebitDate
        delete this.dataSource.sectionData.lastDebitDate
        delete this.dataSource.sectionData.regularAmount
        this.$forceUpdate()
      })
      this.$eventBus.$on('paymentScheduleUpdate', target => {
        this.dataSource.sectionData.debitCount = target.debitCount
        this.dataSource.sectionData.firstDebitDate = target.firstDebitDate
        this.dataSource.sectionData.lastDebitDate = target.lastDebitDate
        this.dataSource.sectionData.regularAmount = target.regularAmount
        this.dataSource.sectionData.apr = target.apr
        // OriginationApi.getLoanFeatureData(this.loanId, 'get', 'payment-option', this.getLoanFeatureDataCallback)
        this.$forceUpdate()
      })
    }
    if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.BANK_RECORDS) {
      this.$eventBus.$on('manualSelectBankRecords', target => {
        const $this = this
        for (const item of target.bankRecordsDataFinalData) {
          item.payrollDate = tool.formatDate(item.payrollDate)
        }

        const updateSectionData = {
          loanId: $this.loanId,
          sectionKey: DataType.LoanSectionKey.STATEMENT,
          featureData: target.bankRecordsDataFinalData,
          provider: target.provider
        }
        OriginationApi.updateSection(updateSectionData, function (result) {
          if (tool.isNotEmpty(result)) {
            if (tool.isNotEmpty(result.warning)) {
              const warningListReturn = result.warning
              for (const item of warningListReturn) {
                const filedKey = $this.assist.tool.transferBlackFieldKey(item)
                if (filedKey === DataType.WarningListEnum.LAST_PAY_DAY) {
                  $this.warningList.lastPayday = true
                }
              }
            } else {
              $this.warningList.lastPayday = false
            }
            const request = {
              loanId: $this.loanId,
              feature: 'PERSONAL,BANK,IBV'
            }
            OriginationApi.getLoanByIdAndFeature(request, function (result) {
              if (tool.isNotEmpty(result)) {
                $this.store.commit('setLoan', { loan: result })
              }
            })
            $this.storeSectionData(result.current)
          }
        }, function (result) {
          popup.popupForWarning(result.message)
        })
      })
    }
    this.$eventBus.$on('broadcastLockedId', target => {
      this.currentLockedId = target
    })
    if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.PERSONAL) {
      this.$eventBus.$on('broadcastOptIn', target => {
        this.uploadOptInData(target.optInData)
      })
    }
    if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.EMPLOYMENT) {
      this.$eventBus.$on('broadcastOptIn', target => {
        this.uploadOptInData(target.optInData)
      })
    }
    if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.BANK) {
      this.$eventBus.$on('uploadQuestion', target => {
        this.storeQuestionTemplate()
      })
    }
    this.$eventBus.$on('update-loan-info', target => {
      const feature = this.layoutSetting.section.name
      if (this.$route.path.includes(SystemEnum.ROUTER_PATH.COLLECTION.prefix) && feature === SystemEnum.SECTION_FEATURE.EMPLOYMENT) {
        this.toLoadSectionData()
      }
    })
    this.$eventBus.$on('get-clicked-slave-detail-event', target => {
      const feature = this.layoutSetting.section.name
      if (this.$route.path.includes(SystemEnum.ROUTER_PATH.POST_ORIGINATION.prefix) && feature === SystemEnum.SECTION_FEATURE.LOAN_DETAILS) {
        ProcessingApi.getLoanDetailsBasic({ loanId: target.loanId }, this.getLoanDetailsBasicCallback)
      } else if (this.$route.path.includes(SystemEnum.ROUTER_PATH.COLLECTION.prefix) && feature === SystemEnum.SECTION_FEATURE.COLLECTION_SUMMARY) {
        CollectionApi.getPaymentFeeDetails({ loanId: target.loanId }, this.getCollectionSummaryCallBack)
      }
    })
    this.$eventBus.$on('sectionUpdated', target => {
      this.sectionUpdatedEventHandler(target.current, target.action, target.feature)
    })
    if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.BANK || this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.PERSONAL) {
      this.$eventBus.$on('showBlackListIcon', target => {
        if (target.section === this.layoutSetting.section.name) {
          Object.assign(this.isShowBlackListIcon, target.data)
        }
      })
    }

    if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.PERSONAL || this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.EMPLOYMENT || this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.BANK_RECORDS) {
      this.$eventBus.$on('showWarningListIcon', target => {
        if (target.section === this.layoutSetting.section.name) {
          Object.assign(this.isShowWarningIcon, target.data)
        }
      })
    }
  },
  methods: {
    updatePersonalNameInBlackList (data) {
      this.$emit('updatePersonalName', data)
    },
    updateEmploymentNameInBlackList (data) {
      this.$emit('updateEmploymentName', data)
    },
    getSectionKey (sectionName) {
      switch (sectionName) {
        case 'bank':
          return DataType.LoanSectionKey.BANKING
        case 'payment-option':
          return DataType.LoanSectionKey.PAYMENT_OPTION
        default:
          return sectionName
      }
    },
    getStampCode (sectionName) {
      switch (sectionName) {
        case DataType.LoanSectionKey.PERSONAL:
          return DataType.StampReasonEnum.PERSONAL_DECLINE.value
        case DataType.LoanSectionKey.EMPLOYMENT:
          return DataType.StampReasonEnum.EMPLOYMENT_DECLINE.value
        case 'bank':
          return DataType.StampReasonEnum.BANKING_DECLINE.value
        case 'payment-option':
          return DataType.StampReasonEnum.PAYMENT_DECLINE.value
        default:
          break
      }
    },
    getCollectionSummaryCallBack (result) {
      this.setUpData = result
      this.feeList = this.setUpData.feeList
      this.store.commit('setCollectionSummaryResult', result)
    },
    filterDate (data, title) {
      let result = 'N/A'
      if (title.template === 'collectedDate') {
        result = data.collectedDate
      } else if (title.template === 'inCollectedDay') {
        result = data.inCollectedDay
      } else {
        result = tool.fieldRender(this.dataSource.sectionData, title.template, title.format)
      }
      return result
    },
    showTitle (loanType) {
      return this.loan.loanType === loanType
    },
    showTooltip (speechCraftCode) {
      this.$eventBus.$emit('showTooltips', speechCraftCode)
    },
    isShowElement (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value) && Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    },
    isOperational () {
      for (const item of this.authorization.restricts) {
        if (Object.prototype.hasOwnProperty.call(item, 'loanStatus') && item.loanStatus === this.loan.loanStatus) {
          return true
        }
      }
      return false
    },
    isRetention () {
      const roleCode = this.store.getters.getRoleCode
      return tool.isWithdrawnStatus(this.loan.loanStatus) && tool.isNotEmpty(roleCode) && roleCode === DataType.RoleEnum.RETENTION_AGENT.code
    },
    isEdit () {
      const editArray = [
        DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value
      ]
      return editArray.includes(this.loan.loanStatus)
    },
    isWithdrawnLock () {
      return tool.isWithdrawnStatus(this.loan.loanStatus) && Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    },
    isShowLoanAmountChangeIcon () {
      const loanStatus = this.loan.loanStatus
      const allowShowLoanStatus = [DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value, DataType.LoanStatus.UNDERWRITER_REVIEW.value]
      return this.loanAmountChangeIcon && allowShowLoanStatus.includes(loanStatus) &&
        Authentication.matchElementPrivilege(this.authorization.privileges, DataType.PrivilegeCode.LOAN_AMOUNT_WARNING_ICON, this.assist.dataType.PrivilegeType.EXECUTABLE)
    },
    isShowLoanAmountChangeClass (title) {
      if (title.action === 'triggerRecalculateLoanAmount' || title.label === 'Amount Financed') {
        if (this.loanAmountChangeIcon &&
          Authentication.matchElementPrivilege(this.authorization.privileges, DataType.PrivilegeCode.LOAN_AMOUNT_WARNING_ICON, this.assist.dataType.PrivilegeType.EXECUTABLE)) {
          return 'color: red'
        } else if (title.action === 'triggerRecalculateLoanAmount') {
          return 'color: grey'
        } else if (title.label === 'Amount Financed') {
          return 'color: primary'
        }
      }
    },
    getOptions (options) {
      if (typeof (options) === 'string') {
        // eslint-disable-next-line no-eval
        return eval(options)
      } else {
        return options
      }
    },
    getFullName (data) {
      return {
        fullName: tool.getFullName(data)
      }
    },
    uploadOptInData (optInData) {
      const optInObject = {}
      const optWorkObject = {}
      for (const item of optInData) {
        if (item.fieldKey === 'email') {
          optInObject.emailIsMarketing = item.status.isMarketing
          optInObject.emailIsOperation = item.status.isOperation
          optInObject.email = optInObject.emailIsMarketing || optInObject.emailIsOperation
        } else if (item.fieldKey === 'homePhone') {
          optInObject.homePhoneIsMarketing = item.status.isMarketing
          optInObject.homePhoneIsOperation = item.status.isOperation
          optInObject.homePhoneNotCall = item.status.doNotCall
          optInObject.homePhoneUncontactable = item.status.uncontactable
          optInObject.homePhone = optInObject.homePhoneIsMarketing || optInObject.homePhoneIsOperation || optInObject.homePhoneNotCall || optInObject.homePhoneUncontactable
        } else if (item.fieldKey === 'cellPhone') {
          optInObject.cellPhoneIsMarketing = item.status.isMarketing
          optInObject.cellPhoneIsOperation = item.status.isOperation
          optInObject.cellPhoneNotCall = item.status.doNotCall
          optInObject.cellPhoneUncontactable = item.status.uncontactable
          optInObject.cellPhone = optInObject.cellPhoneIsMarketing || optInObject.cellPhoneIsOperation || optInObject.cellPhoneNotCall || optInObject.cellPhoneUncontactable
        } else if (item.fieldKey === 'workPhone') {
          optWorkObject.workPhoneNotCall = item.status.doNotCall
          optWorkObject.workPhoneUncontactable = item.status.uncontactable
          optWorkObject.workPhone = optWorkObject.workPhoneNotCall || optWorkObject.workPhoneUncontactable
        }
      }
      for (const item of this.optInArray) {
        item.display = optInObject[item.name]
      }
      for (const item of this.emInArray) {
        item.display = optWorkObject[item.name]
      }
    },
    /* start of callback method */
    listQuestionTemplateCallback (result) {
      this.questionTemplate = result
      this.storeQuestionTemplate()
    },
    getLoanQuestionDataCallback (result) {
      this.storeAnswerData(result)
    },
    getPaymentLoanDetailCallback (result) {
      this.storeSectionData(result)
    },
    async getLoanFeatureDataCallback (result) {
      if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.LOAN_DETAILS && tool.isNotEmpty(result)) {
        for (const key of Object.keys(result)) {
          if (result[key] === 0) {
            delete result[key]
          }
        }
        if (tool.isNotEmpty(result.effectiveDate)) {
          this.$eventBus.$emit('judgeSameDayEvent')
        }
        if (!this.isShowPaymentModeHint &&
          tool.isNotEmpty(result.defaultDisbursementMode) &&
          result.defaultDisbursementMode !== DataType.TransactionModeEnum.ACH.value
        ) {
          this.isShowPaymentModeHint = true
          window._VMA.$emit('SHOW_SNACKBAR', {
            text: 'Different Payment Mode selected, needs special revision.',
            color: 'success',
            timeout: 10000
          })
        }
        this.updateLoanAmountChangeIcon(result)
      }
      if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.PERSONAL && tool.isNotEmpty(result)) {
        this.$eventBus.$emit('setPersonalData', result)
      }
      this.storeSectionData(result)
      this.nextTickCallback()
    },
    updateLoanAmountChangeIcon (sectionData) {
      const loanAmount = sectionData.loanAmount
      const approvedAmount = sectionData.approvedAmount
      if (tool.isNotEmpty(loanAmount) && tool.isNotEmpty(approvedAmount) &&
        ((this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value && loanAmount / 2 < approvedAmount) ||
          (this.loan.loanType === DataType.LoanTypeEnum.INSTALLMENT_LOAN.value && loanAmount < approvedAmount))) {
        this.loanAmountChangeIcon = true
      } else {
        this.loanAmountChangeIcon = false
      }
      this.$forceUpdate()
    },
    listProgramDataCallback (result) {
      const roleId = this.$store.getters.getAccount.roleId
      const programArray = []
      // const isShowRoleId = [23, 24, 34, 49, 16, 27, 43, 46, 47, 56]
      const isShowRoleId = [
        DataType.RoleIdEnum.ADMINISTRATOR.value,
        DataType.RoleIdEnum.UNDERWRITER_AGENT.value,
        DataType.RoleIdEnum.UNDERWRITER_SUPERVISOR.value,
        DataType.RoleIdEnum.SUPPORT_AGENT.value,
        DataType.RoleIdEnum.PRODUCTION_MANAGER.value,
        DataType.RoleIdEnum.RETURNING_AGENT.value,
        DataType.RoleIdEnum.RETURNING_CUSTOMER_POC.value,
        DataType.RoleIdEnum.RETENTION_CUSTOMER_SUPERVISOR.value,
        DataType.RoleIdEnum.PRODUCTION_MANAGER_ADMIN.value,
        DataType.RoleIdEnum.RETURNING_CUSTOMER_SUPERVISOR.value
      ]
      for (const program of result) {
        if (!(isShowRoleId.includes(roleId)) && (program.programName === '6+ Loans Repaid')) {
          continue
        }
        programArray.push(program)
      }
      this.store.commit('setProgram', programArray)
      this.storeProgramData(programArray)
    },
    /* end of callback method //:~ */

    /* start of render method */
    nextTickCallback () {
      this.$nextTick(() => {
        if (tool.isNotNull(this.$refs.profileSection)) {
          this.$emit('calcHeight', this.$refs.profileSection.offsetHeight, this.layoutSetting.section.name)
        }
      })
    },
    isDisplayField (fieldKey, loanType) {
      if (this.assist.tool.isNotEmpty(loanType) && loanType.indexOf(this.loan.loanType) === -1) {
        return false
      }

      if (fieldKey !== 'firstDayOfWeek' && fieldKey !== 'firstDayOfMonth' && fieldKey !== 'secondDayOfMonth') {
        return true
      }

      const payrollFrequency = this.dataSource.sectionData.payrollFrequency
      return tool.displayByPayrollFrequency(fieldKey, payrollFrequency)
    },
    isShowPaymentMode (individualTransactionMode) {
      let portfolioTransactionMode = this.portfolioJson.individualTransactionMode
      portfolioTransactionMode = tool.isNotEmpty(portfolioTransactionMode) ? portfolioTransactionMode : '0'
      if (tool.isNotEmpty(individualTransactionMode) && individualTransactionMode !== portfolioTransactionMode) {
        return false
      } else {
        return true
      }
    },
    /* end of render method //:~ */

    /* start of operation method */
    showProfileSectionDialog (action) {
      this.dialog.profileSectionDialog.action = action
      this.dialog.profileSectionDialog.display = true
    },
    storeQuestionTemplate () {
      let questionTemplateData = JSON.parse(JSON.stringify(this.questionTemplate))
      if (tool.isEmpty(questionTemplateData)) {
        questionTemplateData = []
      }

      for (const item of questionTemplateData) {
        if (item.id === 4) {
          const data = this.getFullName(this.store.getters.getLoan)
          item.question = _.template(item.question)({ data: data })
        }
      }
      this.dataSource.questionTemplateData = questionTemplateData

      const questionOptionCache = {}
      for (const item of this.dataSource.questionTemplateData) {
        const optionArray = (item.options).toJson()
        const optionCache = {}
        for (const optionItem of optionArray) {
          optionCache[optionItem.value] = optionItem.text
        }
        questionOptionCache[item.id] = optionCache
      }
      this.extension.questionOptionData = questionOptionCache
    },
    storeAnswerData (answerData) {
      if (this.assist.tool.isEmpty(answerData)) {
        answerData = []
      }
      answerData = answerData.filter(item => item.question !== 2)
      this.dataSource.answerData = answerData
      const questionAnswerData = {}

      if (answerData.length > 0) {
        for (const item of answerData) {
          const appendix = tool.isNotEmpty(item.appendix) ? item.appendix : ''
          questionAnswerData[item.question] = {
            value: item.answer,
            text: this.extension.questionOptionData[item.question][item.answer],
            appendix: appendix
          }
          if (item.question === 2) {
            this.store.commit('setQuestionAppendix', appendix)
          }
        }
      } else {
        const questions = Object.keys(this.extension.questionOptionData)
        for (const question of questions) {
          questionAnswerData[question] = null
        }
      }
      this.extension.questionAnswerData = questionAnswerData
    },
    storeStampData (res) {
      if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.PERSONAL) {
        this.$store.commit('setLatestPersonalStamp', res)
      }
      const $this = this
      this.dataSource.sectionStamp = []
      const stampedBy = JSON.parse(res.stampedBy)
      const icon = $this.getStampIcon(res.type)
      if (tool.isNotEmpty(icon)) {
        $this.dataSource.sectionStamp.push({
          stampedBy: tool.getFullName(stampedBy),
          stampedAt: res.stampedAt,
          type: res.type,
          code: res.code,
          icon: icon.name,
          color: icon.color
        })
      }
      $this.$forceUpdate()
    },
    storeSectionData (sectionData) {
      const year = new Date().getFullYear()
      const lastdate = year + '-' + 12 + '-' + 31
      const sectionName = this.layoutSetting.section.name
      if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.PERSONAL) {
        this.$store.commit('setLanguageCode', sectionData)
      }
      if (this.layoutSetting.section.name === SystemEnum.SECTION_FEATURE.LOAN_DETAILS) {
        let firstCreditDate
        if (this.$route.path.includes(SystemEnum.ROUTER_PATH.PRE_ORIGINATION.prefix)) {
          firstCreditDate = sectionData.firstCreditDate
          if (typeof firstCreditDate === 'number') {
            firstCreditDate = tool.formatDate(firstCreditDate)
          }
          this.$store.commit('setFirstCreditDate', firstCreditDate)
        } else if (this.$route.path.includes(SystemEnum.ROUTER_PATH.POST_ORIGINATION.prefix)) {
          this.store.commit('setDisbursementDate', sectionData.dueDateText ? sectionData.dueDateText : lastdate)
          this.store.commit('setFirstCreditDate', sectionData.firstCreditDateText ? sectionData.firstCreditDateText : this.store.getters.getNextBusinessDay)
          this.store.commit('setPPSNextAdvanceNumber', sectionData.advanceNo ? parseInt(sectionData.advanceNo.split('-')[2]) : 0)
        }
        if (tool.isEmpty(this.portfolioJson.individualTransactionMode) || this.portfolioJson.individualTransactionMode === '0' ||
          this.$route.path.includes(SystemEnum.ROUTER_PATH.POST_ORIGINATION.prefix)) {
          sectionData.paymentMode = sectionData.defaultDisbursementMode
        }
      }
      switch (this.layoutSetting.section.type) {
        case 'form':
          if (this.assist.tool.isEmpty(sectionData)) {
            sectionData = {}
          } else {
            if (sectionName === SystemEnum.SECTION_FEATURE.LOAN_DETAILS) {
              delete sectionData.totalAmount
              const transferredAmount = sectionData.transferredAmount || 0
              sectionData.totalAmount = (transferredAmount + sectionData.approvedAmount) || 'N/A'
            }
            if (sectionName === SystemEnum.SECTION_FEATURE.LOAN_DETAILS &&
              this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
              const loanAmount = sectionData.loanAmount
              if (tool.isNotEmpty(loanAmount)) {
                sectionData.availableAdvanceAmount = loanAmount / 2
              }
              if (this.loan.phase === DataType.LoanPhaseEnum.LOAN_ORIGINATION.value) {
                sectionData.advanceNo = this.loan.loanNo + '-1'
                sectionData.stage = 'one'
              }
            }
          }
          this.dataSource.sectionData = sectionData
          break
        case 'table':
          if (this.assist.tool.isEmpty(sectionData)) {
            sectionData = []
          }

          for (const item of sectionData) {
            if (item.payrollDate < 0 || !item.payrollDate.toString().includes('-')) {
              item.payrollDate = tool.formatDate(item.payrollDate)
            }
          }
          this.dataSource.tableData = sectionData
          break
        default:
          break
      }

      this.store.commit('setLoan', { loan: sectionData, sectionName: this.layoutSetting.section.name })
      if (sectionName === SystemEnum.SECTION_FEATURE.PERSONAL) {
        this.$eventBus.$emit('uploadQuestion')
      }
    },
    storeProgramData (programArray) {
      this.dataSource.programArray = programArray
      this.extension.programData = []

      for (const program of programArray) {
        this.extension.programData.push({
          value: program.id,
          text: program.programName
        })
      }
    },
    /* end of operation method //:~ */

    /* start of event method */
    toLoadSectionData () {
      this.loanIdWatcher(this.loanId)
    },
    initStamp (sectionKey) {
      if (tool.isNotEmpty(this.loanId)) {
        const $this = this
        if (sectionKey === SystemEnum.SECTION_FEATURE.BANK) {
          sectionKey = 'banking'
        }
        const payload = {
          loanId: this.loanId,
          feature: 'STAMP',
          condition: {
            sectionKey: sectionKey
          }
        }
        OriginationApi.listSectionFeature(payload, function (callbackData) {
          $this.storeStampData(callbackData[0])
        })
      }
    },
    getStampIcon (type) {
      const stampAction = DataType.StampActionTypeEnum
      for (const key in stampAction) {
        const stamp = stampAction[key]
        if (type === stamp.value) {
          return {
            name: stampAction[key].icon,
            color: stampAction[key].color
          }
        }
      }
      return {}
    },
    async loanIdWatcher (loanId) {
      const feature = this.layoutSetting.section.name
      await this.getMetaDataInfo(loanId)
      if (feature === SystemEnum.SECTION_FEATURE.BANK_RECORDS) {
        await OriginationApi.getLoanFeatureData(loanId, 'list', feature, this.getLoanFeatureDataCallback)
      } else if (this.$route.path.includes(SystemEnum.ROUTER_PATH.COLLECTION.prefix) && feature === SystemEnum.SECTION_FEATURE.COLLECTION_SUMMARY) {
        switch (this.loan.loanType) {
          case DataType.LoanTypeEnum.INSTALLMENT_LOAN.value:
            this.$eventBus.$emit('get-clicked-slave-detail-event', { loanId: loanId })
            break
          case DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value:
            this.$eventBus.$emit('get-latest-slave-detail-event', 'update loan history')
            break
          default:
            break
        }
      } else if (!tool.isWithdrawnStatus(this.loan.loanStatus) && this.$route.path.includes(SystemEnum.ROUTER_PATH.POST_ORIGINATION.prefix) && feature === SystemEnum.SECTION_FEATURE.LOAN_DETAILS) {
        switch (this.loan.loanType) {
          case DataType.LoanTypeEnum.INSTALLMENT_LOAN.value:
            await OriginationApi.getLoanFeatureData(loanId, 'get', feature, this.getLoanFeatureDataCallback)
            this.$eventBus.$emit('get-clicked-slave-detail-event', { loanId: loanId })
            break
          case DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value:
            this.$eventBus.$emit('get-latest-slave-detail-event', 'update loan history')
            break
          default:
            break
        }
      } else {
        await OriginationApi.getLoanFeatureData(loanId, 'get', feature, this.getLoanFeatureDataCallback)
      }
    },
    async getMetaDataInfo (loanId) {
      if (this.assist.tool.isNotEmpty(this.layoutSetting.metadata)) {
        for (const metadata of this.layoutSetting.metadata) {
          switch (metadata.name) {
            case 'program':
              await RuntimeApi.fetchProgramByPortfolioId(this.loan.portfolioId, this.listProgramDataCallback)
              break
            case 'questionType':
              await RuntimeApi.fetchQuestionTemplateByGroupId(metadata.value, this.listQuestionTemplateCallback)
              await OriginationApi.listLoanQuestionData(loanId, this.getLoanQuestionDataCallback)
              break
            default:
              break
          }
        }
        this.$forceUpdate()
      }
    },
    async getLoanDetailsBasicCallback (result) {
      this.storeSectionData(result)
    },
    sectionUpdatedEventHandler (newAppData, action, feature) {
      const sectionData = newAppData.sectionData
      const tableData = newAppData.tableData
      const answerData = newAppData.answerData
      if (this.layoutSetting.section.name === feature) {
        this.getMetaDataInfo(this.loanId)
        if (this.loan.phase === DataType.LoanPhaseEnum.LOAN_ORIGINATION.value || this.loan.loanStatus === DataType.LoanStatus.POSITIVE_WITHDRAWN.value || this.loan.loanStatus === DataType.LoanStatus.NEGATIVE_WITHDRAWN.value) {
          const originalTableData = JSON.parse(JSON.stringify(this.dataSource.tableData))
          originalTableData.sort(this.assist.tool.compareArr('date'))
          tableData.sort(this.assist.tool.compareArr('date'))
          if (action !== 'AUDIT' && Crypto.md5(JSON.stringify(originalTableData)) !== Crypto.md5(JSON.stringify(tableData))) {
            this.storeSectionData(tableData)
          }

          if (this.assist.tool.isNotEmpty(answerData)) {
            this.storeAnswerData(answerData)
          }

          if (action !== 'AUDIT' && this.assist.tool.isNotEmpty(sectionData)) {
            this.storeSectionData(sectionData)
          }
        } else {
          this.$eventBus.$emit('update-history-settings')
          this.storeSectionData(sectionData)
        }
      }
    },
    hidePaymentPlanEventHandler () {
      this.dialog.paymentPlanDialog.display = false
    },
    hideSpecialConsiderationCustomerEventHandler () {
      this.dialog.specialConsiderationCustomerDialog.display = false
    },
    hideManualSetLoanAmountEventHandler (loanAmount) {
      this.dialog.manualSetLoanAmountDialog.display = false
    },
    /* end of event method //:~ */

    /* ******************************************** start of original ********************************************* */
    triggerAmount (action) {
      switch (action) {
        case 'triggerRecalculateLoanAmount':
          this.triggerRecalculateLoanAmount()
          break
        case 'triggerAdjustApprovedAmount':
          this.triggerAdjustApprovedAmount()
          break
        case 'triggerSpecialConsiderationCustomer':
          this.triggerSpecialConsiderationCustomer()
          break
        default:
          break
      }
    },
    triggerRecalculateLoanAmount () {
      this.$eventBus.$emit('calculateLoanSize')
    },
    triggerAdjustApprovedAmount () {
      const sectionData = this.dataSource.sectionData
      const isShowDialog = tool.isNotEmpty(sectionData) && tool.isNotEmpty(sectionData.loanAmount) && sectionData.loanAmount > 0
      if (isShowDialog) {
        this.dialog.paymentPlanDialog.display = isShowDialog
      } else {
        this.$swal({ type: 'warning', text: 'The customer has no available loan amount', showCancelButton: false })
      }
    },
    triggerSpecialConsiderationCustomer () {
      this.dialog.manualSetLoanAmountDialog.display = true
      // if ($this.loan.category === DataType.CategoryEnum.RETURNING_CUSTOMER.value) {
      //   if (Authentication.matchElementPrivilege(this.authorization.privileges, DataType.PrivilegeCode.SPECIAL_CONSIDERATION, this.assist.dataType.PrivilegeType.EXECUTABLE)) {
      //     $this.dialog.manualSetLoanAmountDialog.display = true
      //   } else {
      //     $this.dialog.specialConsiderationCustomerDialog.display = true
      //   }
      // } else if (this.loan.source === DataType.LoanSourceEnum.EXPRESS.value + DataType.LoanSourceEnum.VOIDED.value) {
      //   // voided / manually Voided
      //   OriginationApi.getExpressSourceLoan(this.loanId, function (result) {
      //     if (tool.isNotEmpty(result) && tool.isNotEmpty(result.loanAmount)) {
      //       $this.manualSetLoanAmountMax = result.loanAmount
      //       if (Authentication.matchElementPrivilege($this.authorization.privileges, DataType.PrivilegeCode.SPECIAL_CONSIDERATION, $this.assist.dataType.PrivilegeType.EXECUTABLE)) {
      //         $this.dialog.manualSetLoanAmountDialog.display = true
      //       } else {
      //         $this.dialog.specialConsiderationCustomerDialog.display = true
      //       }
      //     } else {
      //       $this.dialog.specialConsiderationCustomerDialog.display = true
      //     }
      //   })
      // } else if ($this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value || $this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value) {
      //   if (Authentication.matchElementPrivilege(this.authorization.privileges, DataType.PrivilegeCode.SPECIAL_CONSIDERATION, this.assist.dataType.PrivilegeType.EXECUTABLE)) {
      //     $this.dialog.manualSetLoanAmountDialog.display = true
      //   } else {
      //     $this.dialog.specialConsiderationCustomerDialog.display = true
      //   }
      // } else {
      //   $this.dialog.specialConsiderationCustomerDialog.display = true
      // }
    },
    hasSpecialConsiderationCustomer (iconItem) {
      if (iconItem.action === 'triggerSpecialConsiderationCustomer') {
        return tool.isEmpty(this.dataSource.sectionData.loanAmount) ||
          this.dataSource.sectionData.loanAmount === 0 ||
          this.loan.category === DataType.CategoryEnum.RETURNING_CUSTOMER.value ||
          this.loan.category === DataType.CategoryEnum.NEW_CUSTOMER.value ||
          this.loan.source === DataType.LoanSourceEnum.EXPRESS.value + DataType.LoanSourceEnum.VOIDED.value ||
          (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value && this.dataSource.sectionData.loanAmount > 200)
      }
      return true
    }
    /* ******************************************** end of original ********************************************* */
  }
}
</script>
<style lang="scss" scoped>
.profile-section {
  background: #F5F5F5;
  padding: 20px;
  margin-top: 0 !important;
  .section-header {
    margin-bottom: -15px;
    padding-top: 12px;
    height: 36px;
    .section-name {
      font-weight: 600;
      font-size: 12px;
      text-transform: uppercase;
      display: inline-block;
    }
    .section-action {
      text-align: right;
      font-size: 20px;
    }
  }
  .section-banner {
    margin: 10px 0;
    font-size: 20px;
    .row {
      margin: auto !important;
    }
  }
  .section-form {
    font-size: 14px;
    .row {
      margin: auto !important;
    }
    .flex {
      overflow: visible;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .field-container {
      padding-left: 3px !important;
      .field-value {
        display: initial !important;
      }
    }
  }
  .section-card {
    font-size: 14px;
    display: flex;
    margin-top: 20px;
    justify-content: space-around;
    .cardClass {
      width: 33%;
      height: 80px;
      text-align: center;
    }
  }
  .section-question {
    color: #222222
  }
  .section-table {
    margin-top: 10px;
  }
  .section-header .flex, .section-banner .flex {
    padding: 0 12px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
